# StickyBox tries to find the element's scroll container before the element
# is mounted in the DOM. This causes it to fallback to "window"
# Creating this wrapper component, with a slight delay at componentDidMount
# allows StickyBox to find the div
# https://github.com/codecks-io/react-sticky-box/issues/7

React = require 'react'
StickyBox = require('react-sticky-box').default
t = require('views/internal/recup-with-helpers')()

module.exports = class StickyBoxWaitForMount extends React.Component
  constructor: (props) ->
    super props
    @state = { isMounted: false }

  componentDidMount: ->
    setTimeout(=> @setState({ isMounted: true }))

  render: t.renderable ->
    if @state.isMounted
      t.tag StickyBox, @props
    else
      t.div()



// WEBPACK FOOTER //
// ./app/scripts/views/lib/sticky-box-wait-for-mount.coffee